import { render } from "./PatientMap.vue?vue&type=template&id=662f3634"
import script from "./PatientMap.vue?vue&type=script&lang=js"
export * from "./PatientMap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__